<template>
  <div class="c-select">
    <select :name="name" :value="modelValue" :disabled="disabled" @change="$emit('update:modelValue', $event.target.value)">
      <option value="" disabled>{{ $t('labels.placeholder.select') }}</option>
      <option v-for="(val, key) in computedOptions" :key="key" :value="val">
        {{ key }}
      </option>
    </select>
  </div>
</template>

<script>
// selectの初期値を「選択してください」にするためにvalueの初期値はnullを渡すこと。
// 親でv-modelを使えます。
export default {
  name: 'Select',
  props: {
    // 他にも型があれば追加
    modelValue: [String, Number],
    options: [Array, Object],
    name: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    computedOptions() {
      // 順番を入れ替えないこと。（typeof this.optionsはArrayでも'object'を返す）
      if (Array.isArray(this.options)) {
        const obj = {}
        this.options.map(v => {
          obj[v] = v
        })
        return obj
      }

      if (typeof this.options === 'object') { return this.options }
      throw Error
    }
  }
}
</script>
